import BarChartCosting from '../graphs/barChartCosting';
import LineChartCosting from '../graphs/lineChartCosting';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import NavBarMenu from '../NavBarMenu';
import FooterMenu from '../FooterMenu';

function Costing() {
    return (
      <>
        <NavBarMenu/>
        <main>
            <Container fluid>
                <Row className="display-flex">
                    <Col>
                        <LineChartCosting/>
                    </Col>
                </Row>
                <Row className="display-flex">
                    <Col >
                        <BarChartCosting/>
                    </Col>
                </Row>
            </Container>
        </main>
        <FooterMenu />
      </>
    );
}
export default Costing